import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";

import "./Address.css";
import { useFormik } from "formik";
import {
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  Rating,
  Select,
  MenuItem,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useEffect } from "react";
import {
  BillingAddressSchema,
  ShippingAddressSchema,
} from "../../utils/validationSchemas";
// import { getStateApi } from "../../redux/features/address/stateSlice";
// import { getCityApi } from "../../redux/features/address/citySlice";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import { getProfileApi } from "../../app/slices/profileSlice";
// import { userAddressApi } from "../../app/slices/user/userAddressSlice";
import { getCityApi } from "../../app/slices/address/citySlice";
import { getStateApi } from "../../app/slices/address/stateSlice";
import { razorpayOrderApi } from "../../app/slices/razorpay/razorpayOrderSlice";
import { razorpaySpotGoldOrderApi } from "../../app/slices/razorpay/razorpaySpotGoldOrderSlice";
// import { usersApi } from "../../app/slices/usersSlice";
import axios from "axios";
import axiosInstance from "../../utils/axiosInstance";
// import { razorpayOrderApi } from "../../redux/features/razorpay/razorpayOrderSlice";
// import { razorpaySpotGoldOrderApi } from "../../redux/features/razorpay/razorpaySpotGoldOrderSlice";
// import { getProfileApi } from "../../redux/features/profileSlice";
// import { userAddressApi } from "../../redux/features/user/userAddressSlice";

const steps = ["Billing Address", "Shipping Address", "Payment"];

export default function Checkout() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const cardApi = async () => {
    let URL = `/userjewellery`;
    // let URL = `${baseUrl}/user`;
    try {
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      let response = await axiosInstance.get(URL);
      // let response = await axios.get(URL, { headers });
      setUsersList(response?.data?.data);
    } catch (error) {
      console.log("error: ", error);
    }
  };
  useEffect(() => {
    cardApi();
  }, []);

  // const baseUrl = import.meta.env.VITE_BASE_URL;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  // location.state
  // console.log("location.state.products: ", location.state.products);
  // useEffect(() => {
  //   dispatch(usersApi());
  // }, [dispatch]);
  // const UsersliceResponse = useSelector((state) => state.users.users.data);
  const [UsersList, setUsersList] = React.useState([]);

  // useEffect(() => {
  //   if (UsersliceResponse) {
  //     setUsersList(UsersliceResponse);
  //   }
  // }, [UsersliceResponse]);
  // const users = [
  //   { id: 1, name: 'Alice', email: 'alice@example.com' },
  //   { id: 2, name: 'Bob', email: 'bob@example.com' },
  //   { id: 3, name: 'Charlie', email: 'charlie@example.com' },
  // ];

  const [selectedUser, setSelectedUser] = React.useState(null);
  // console.log("selsectedUser: ", selectedUser);

  // Handler for when the user selects an option
  const handleUserChange = (event, newValue) => {
    setSelectedUser(newValue);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const sliceResponse = useSelector(
    (state) => state.spotGoldProductDetailsSlice.spotGoldProductDetails.data,
  );

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  // ============================PROFILE===================================

  const profileSliceResponse = useSelector(
    (state) => state?.profileSlice?.data,
  );

  // useEffect(() => {
  //   dispatch(getProfileApi());
  // }, []);

  // ========================================USER ADDRESS===============================

  const userAddressSlice = useSelector(
    (state) => state.userAddressSlice.data.data,
  );

  // useEffect(() => {
  //   dispatch(userAddressApi());
  // }, []);

  // -------------------------BILLING ADDRESS---------------------

  // const dispatch = useDispatch();
  // const stateSliceResponse = useSelector((state) => state.stateSlice.data);
  const stateSliceResponse = useSelector(
    (state) => state.augmontstateSlice.data,
  );
  const citySliceResponse = useSelector((state) => state.augmontcitySlice.data);

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      pan: "",
      dob: "",
      address: "",
      state: "",
      city: "",
      landmark: "",
      zip: "",
    },
    validationSchema: BillingAddressSchema,
    onSubmit: (values) => {
      handleNext();
    },
    validateOnMount: false, // No validation on mount
    validateOnChange: false, // No validation on change
    validateOnBlur: true, // Validate only on blur
  });

  const handleStateChange = (event, value) => {
    if (value) {
      dispatch(getCityApi(value.id));
      setFieldValue("state", value ? value.name : "");
    } else {
      console.log("Selection cleared");
    }
  };

  const handleCityChange = (event, value) => {
    setFieldValue("city", value ? value.name : "");
  };

  useEffect(() => {
    dispatch(getStateApi());
  }, []);

  useEffect(() => {
    if (userAddressSlice?.length > 0 && userAddressSlice[0]?.stateName) {
      dispatch(getStateApi(userAddressSlice[0].stateName));
    }
  }, [userAddressSlice, values]);

  const { landMark, postalCode, stateName, cityName, customerAddress } =
    userAddressSlice?.[0] || [];

  useEffect(() => {
    if (selectedUser) {
      // const profileData = selectedUser.name
      let firstName = "";
      let lastName = "";

      if (selectedUser?.name) {
        const nameParts = selectedUser.name.trim().split(" ");
        firstName = nameParts[0] || ""; // First part is considered as the first name

        // If there's only one part, use it as both first and last name
        if (nameParts.length > 1) {
          lastName = nameParts.slice(1).join(" "); // Remaining parts are considered as the last name
        } else {
          lastName = firstName; // If no last name, use the first name as the last name
        }
      }

      setValues({
        dob: selectedUser?.dob || "",
        phone: selectedUser?.phone || "",
        firstName: firstName || "",
        lastName: lastName || "",
        email: selectedUser?.email || "",
        pan: selectedUser?.pan_number || "",
        landmark: landMark || "",
        zip: postalCode || "",
        state: selectedUser.state || "",
        city: selectedUser.city || "",
        address: customerAddress || "",
        // city: cityName || "",
        // landmark: userAddressSlice[0]?.landMark || "",
        // zip: userAddressSlice[0]?.postalCode || "",
        // state: userAddressSlice[0]?.stateName || "",
        // city: userAddressSlice[0]?.cityName || "",
        // address: userAddressSlice[0]?.customerAddress || "",
      });
    } else {
      resetForm();
    }
  }, [selectedUser, setValues, resetForm]);

  // ===================================SHIPPING ADDRESS============================================

  const [checkBoxState, setCheckBoxState] = React.useState(false);

  const formikShipping = useFormik({
    initialValues: {
      address: "",
      state: "",
      city: "",
      landmark: "",
      zip: "",
    },
    validationSchema: ShippingAddressSchema,
    onSubmit: (values) => {
      console.log(
        "Shipping Address formik VALUES+++++++++++:",
        formikShipping.values,
      );
      // console.log("Shipping Address VALUES---------------:", values);
      handleNext();
    },
  });

  const handleShippingState = (event, value) => {
    if (value) {
      dispatch(getCityApi(value.id));
      formikShipping.setFieldValue("state", value ? value.name : "");
    } else {
      console.log("Selection cleared");
    }
  };

  const handleShippingCity = (event, value) => {
    formikShipping.setFieldValue("city", value ? value.name : "");
  };

  const handleCheckboxChange = (event) => {
    setCheckBoxState(!checkBoxState);
  };

  useEffect(() => {
    if (checkBoxState) {
      formikShipping.setValues({
        address: values.address,
        state: values.state,
        city: values.city,
        landmark: values.landmark,
        zip: values.zip,
      });
    } else {
      formikShipping.resetForm();
    }
  }, [checkBoxState, values]);

  // ========================================PAYMENT===============================

  const razorpayOrderSliceResponse = useSelector(
    (state) => state.razorpayOrderSlice.data.data,
  );

  // console.log(
  //   "DISHANT SLICE RESPONSE=======================",
  //   razorpayOrderSliceResponse
  // );

  const paymentHandler = (TotalAmount) => {
    if (!TotalAmount) {
      toast.error("Please try again later...");
      return;
    }

    const payload = {
      TotalAmount: location.state.totalAmount,
    };
    dispatch(razorpayOrderApi(payload));
  };

  const transformedProducts = location?.state?.products?.map((product) => ({
    productId: product.product_id,
    quantity: product.quantity,
    paymentTypeId: 0,
    productName: product.productDetails.productName,
    productImage: product.productDetails.productImage,
    productWeight: product.productDetails.weight,
    productTotalAmount:
      product.productDetails.productPrice[0]?.finalProductPrice *
      product.quantity,

    // Assuming paymentTypeId is always 0 as per your request
  }));
  // console.log("transformedProducts: ", transformedProducts);

  const handleOpenRazorpay = async () => {
    if (!window.Razorpay) {
      console.error(
        "Razorpay SDK not loaded. Please ensure the script is included in the HTML.",
      );
      return;
    }

    const options = {
      // key: `${import.meta.env.REACT_APP_RAZORPAY_KEY}`,
      key: `${import.meta.env.VITE_RAZORPAY_KEY}`,
      // key: "rzp_test_Q9Dy1PLgZSqKLZ",
      amount: razorpayOrderSliceResponse?.amount,
      currency: razorpayOrderSliceResponse?.currency,
      name: "Bharat Batuk Pvt.ltd.",
      description: "XYZ",
      order_id: razorpayOrderSliceResponse?.id,
      handler: function (response) {
        // console.log("DISHANT RESPONSE+++++++++++++++++++", response);

        const payload = {
          productDetails: transformedProducts,
          metalType: "gold",
          mobileNumber: values.phone,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          customerAddress: values.address,
          landMark: values.landmark,
          postalCode: values.zip,
          stateName: values.state,
          cityName: values.city,
          shippingAddress: values.address,
          shippingLandMark: values.landmark,
          shippingPostalCode: values.zip,
          shippingStateName: values.state,
          shippingCityName: values.city,
          panCardNumber: values.pan,
          dateOfBirth: values.dob,
        };

        const orderResponse = dispatch(razorpaySpotGoldOrderApi(payload));

        // console.log("DISHANT=================", orderResponse);
        Swal.fire({
          title: "Payment Successful",
          icon: "success",
        });
        navigate("/history");
      },
      prefill: {
        name: values.firstName + " " + values.lastName,
        email: values.email,
        contact: values.phone,
      },
    };
    // console.log("options: ", options);

    const rzp = new window.Razorpay(options);

    // Handling payment failure
    rzp.on("payment.failed", function (response) {
      // console.log("Payment failed:", response);
      Swal.fire({
        title: "Payment Failed",
        text: response.error.description,
        icon: "error",
      });
    });

    rzp.open();
  };

  useEffect(() => {
    if (razorpayOrderSliceResponse?.id) {
      handleOpenRazorpay();
    }
  }, [razorpayOrderSliceResponse]);

  // const [currentIndex, setCurrentIndex] = React.useState(0);

  // const handleThumbnailClick = (index) => {
  //   setCurrentIndex(index);
  // };

  const [orderTransactionId, setOrderTransactionId] = React.useState("");
  // console.log("orderTransactionId: ", orderTransactionId);
  const [setsendLinkLoading, setsetsendLinkLoading] = React.useState(false);
  const getTransactionIdApi = async () => {
    setsetsendLinkLoading(true);
    const payload = {
      productDetails: transformedProducts,
      metalType: "gold",
      mobileNumber: values.phone,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      customerAddress: values.address,
      landMark: values.landmark,
      postalCode: values.zip,
      stateName: values.state,
      cityName: values.city,
      shippingAddress: values.address,
      shippingLandMark: values.landmark,
      shippingPostalCode: values.zip,
      shippingStateName: values.state,
      shippingCityName: values.city,
      panCardNumber: values.pan,
      dateOfBirth: values.dob,
      flag: "admin",
    };

    try {
      // const response = await axios.post(
      const response = await axiosInstance.post(
        `/orderQuote/${selectedUser._id}`,
        payload,
      );

      const merchantTransactionId = response?.data?.data?.transactionId || "";

      if (!merchantTransactionId) {
        return Swal.fire({
          title: "Unable to get transaction Id",
          icon: "error",
        });
      }

      setOrderTransactionId(merchantTransactionId);

      if (merchantTransactionId) {
        const payload = {
          TotalAmount: location.state.totalAmount,
          merchantTransactionId: merchantTransactionId,
        };

        try {
          const res = await axiosInstance.post(
            `/paymentLink/${selectedUser._id}`,
            payload,
            // {
            //   headers: {
            //     "Content-Type": "application/json",
            //     Accept: "application/json",
            //     Authorization: `Bearer ${token}`,
            //   },
            // }
            // const res = await axios.post(
            //   `${baseUrl}/paymentLink/${selectedUser._id}`,
            //   payload,
            //   {
            //     headers: {
            //       "Content-Type": "application/json",
            //       Accept: "application/json",
            //       Authorization: `Bearer ${token}`,
            //     },
            //   }
          );
          // console.log("respomse nnnnnnnnnnnnn", res.data.data);
          const response = res.data;
          if (response.error == false) {
            Swal.fire({
              text: response?.data?.message || "Link Sent Successfully",
              icon: "success",
              timer: 3000,
              showConfirmButton: false,
            });
            setTimeout(() => {
              navigate("/jewellery_catalogue");
            }, 1000);
            // toast.success("Link Send Successful!");
          }
        } catch (error) {
          toast.error("Failed to send the link. Please try again.");
        }

        // dispatch(razorpayOrderApi(payload));
        // handleSendLink();
        // createOrderApi(payload);
      } else {
        toast.error("Something Went Wrong!!!");
      }
    } catch (error) {
      setsetsendLinkLoading(false);
      console.error("Error fetching transaction ID:", error);
    } finally {
      setsetsendLinkLoading(false);
    }
  };

  const handleClear = () => {
    setFormErrors({});
    // setSelectedOption(null);
    // setStartDate("");
    // setEndDate("");
    // setdata(null);
    setSelectedId("");
    setInputValue("");
  };
  const [formErrors, setFormErrors] = React.useState({});

  const [inputValue, setInputValue] = React.useState(""); // For input field
  const [filteredOptions, setFilteredOptions] = React.useState([]); // For filtered results
  const [showDropdown, setShowDropdown] = React.useState(false); // Dropdown visibility
  const [selectedId, setSelectedId] = React.useState(""); // Tracks selected option's _id

  const inputRef = React.useRef(null);

  // Handle input changes and filter the dropdown list
  const handleInputChange = (e) => {
    setFormErrors({});

    const value = e.target.value;
    setInputValue(value);

    // Filter options based on input
    // const filtered = options.filter((option) =>
    const filtered = UsersList?.filter(
      (option) =>
        option?.name?.toLowerCase()?.includes(value?.toLowerCase()) ||
        option?.phone?.toLowerCase()?.includes(value?.toLowerCase()),
      // option?.username.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(filtered || []);

    setShowDropdown(true);
  };

  // Handle focus to show all options initially
  const handleFocus = () => {
    setFormErrors({});

    // setFilteredOptions(options); // Show all options on focus
    setFilteredOptions(UsersList || []); // Show all options on focus
    setShowDropdown(true);
  };

  // Handle selection of an option
  const handleOptionClick = (option) => {
    setInputValue(option?.name); // Set input field to selected name
    setSelectedId(option?._id); // Store the selected _id
    setShowDropdown(false);

    // Store the selected user
    setSelectedUser(option);
  };

  // Close dropdown when clicking outside
  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 150); // Delay to allow selection clicks
  };

  return (
    <div>
      {/* <Navbar /> */}
      <div className="main-box" style={{ padding: "20px" }}>
        {/* ======================PRODUCT DETAILS================================== */}

        <div
          style={{
            // margin: "20px",
            backgroundColor: "white",
            padding: "20px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            borderRadius: "10px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5>Order Summary</h5>
            <h5>Subtotal: ₹{location?.state?.totalAmount}</h5>
          </div>
          <hr />
          {location?.state?.products?.map((item, i) => (
            <div key={i}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  // border: "1px solid lightgray",
                  padding: "10px",
                  borderRadius: "10px",
                  marginBottom: "20px",
                }}
              >
                <div style={{ width: "20%" }}>
                  <img
                    src={item.productDetails.productImage}
                    alt="item"
                    width="100%"
                  />
                </div>
                <div>
                  <h5>{item.productDetails.productName}</h5>
                  <div>Weight: {item.productDetails.weight}gm</div>
                  <div>Quantity: {item.quantity}</div>
                  {/* <Rating name="read-only" defaultValue={4} readOnly /> */}
                  <h5>
                    ₹{item.productDetails.productPrice[0]?.finalProductPrice}
                  </h5>
                </div>
              </div>
              <hr />
            </div>
          ))}
        </div>

        {/* ==============================ADDRESS============================== */}

        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {activeStep === 0 && (
                <div>
                  <form className="main-container" onSubmit={handleSubmit}>
                    <div
                    // className="inputfield-container"
                    >
                      <Box sx={{ position: "relative" }}>
                        <TextField
                          autoComplete="off"
                          label="Search User"
                          size="small"
                          inputRef={inputRef}
                          value={inputValue}
                          // Autocomplete={false}
                          onChange={handleInputChange}
                          onFocus={handleFocus} // Show all options on focus
                          onBlur={handleBlur}
                          // placeholder="Search Partner"
                          variant="outlined"
                          fullWidth
                          // error={!!formErrors.SelectPartner}
                          // helperText={formErrors.SelectPartner}
                          InputProps={{
                            sx: {
                              // borderRadius: "8px",
                              // "&:hover": { borderColor: "#007bff" },
                            },
                          }}
                        />

                        {/* Dropdown List */}
                        {showDropdown && (
                          <List
                            sx={{
                              position: "absolute",
                              width: "100%", // Matches TextField width
                              maxHeight: "200px",
                              overflowY: "auto",
                              backgroundColor: "white",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                              zIndex: 1301, // High z-index (MUI default modal z-index is 1300)
                              marginTop: "4px",
                              padding: 0,
                            }}
                          >
                            {filteredOptions?.length > 0 ? (
                              filteredOptions?.map((option) => (
                                <ListItem
                                  key={option._id}
                                  button
                                  onMouseDown={() => handleOptionClick(option)}
                                  sx={{
                                    "&:hover": { backgroundColor: "#f0f0f0" },
                                    cursor: "pointer",
                                  }}
                                >
                                  <ListItemText
                                    primary={
                                      option?.name
                                        ? option?.name
                                        : option?.phone
                                    }
                                  />
                                  <span style={{ fontSize: 12 }}>
                                    {option?.phone}
                                  </span>
                                </ListItem>
                              ))
                            ) : (
                              <ListItem>
                                <ListItemText
                                  primary="No results found"
                                  sx={{ color: "#999", fontStyle: "italic" }}
                                />
                              </ListItem>
                            )}
                          </List>
                        )}
                      </Box>
                    </div>
                    {/* <div className="inputfield-container">
                      <Autocomplete
                        options={UsersList} // Array of objects
                        getOptionLabel={(option) => option?.name} // Display name property as the label
                        value={selectedUser} // Controlled value
                        onChange={handleUserChange} // Handler for when selection changes
                        size="small"
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select a User"
                            variant="outlined"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        } // Determine equality for selection
                      />
                    </div> */}
                    <div className="inputfield-container">
                      <TextField
                        id="firstName"
                        name="firstName"
                        label="First Name"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.firstName}
                        onChange={handleChange}
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                        // defaultValue="Hello World"
                        // InputProps={{
                        //   readOnly: true,
                        // }}
                      />
                      <TextField
                        id="lastName"
                        name="lastName"
                        label="Last Name"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.lastName}
                        onChange={handleChange}
                        error={!!errors.lastName}
                        helperText={errors.lastName}
                      />
                    </div>
                    <div className="inputfield-container">
                      <TextField
                        id="email"
                        name="email"
                        label="Email"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        // InputProps={{
                        //   readOnly: true,
                        // }}
                      />
                      <TextField
                        id="phone"
                        name="phone"
                        label="Phone Number"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.phone}
                        onChange={handleChange}
                        error={!!errors.phone}
                        helperText={errors.phone}
                        // InputProps={{
                        //   readOnly: true,
                        // }}
                      />
                    </div>
                    <div className="inputfield-container">
                      <TextField
                        id="pan"
                        name="pan"
                        label="Pan Number"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.pan}
                        onChange={handleChange}
                        error={!!errors.pan}
                        helperText={errors.pan}
                        // InputProps={{
                        //   readOnly: true,
                        // }}
                      />
                      <TextField
                        id="dob"
                        name="dob"
                        // label="Date Of Birth"
                        variant="outlined"
                        placeholder="date"
                        size="small"
                        type="date"
                        fullWidth
                        value={values.dob}
                        onChange={handleChange}
                        error={!!errors.dob}
                        helperText={errors.dob}
                        // InputProps={{
                        //   readOnly: true,
                        // }}
                      />
                    </div>
                    <div className="inputfield-container">
                      <Autocomplete
                        disablePortal
                        id="state-autocomplete"
                        options={stateSliceResponse?.data || []}
                        getOptionLabel={(option) => option.name}
                        fullWidth
                        size="small"
                        value={
                          (stateSliceResponse?.data || []).find(
                            (option) => option.name === values.state,
                          ) || null
                        }
                        onChange={handleStateChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="State"
                            error={!!errors.state}
                            helperText={errors.state}
                          />
                        )}
                      />
                      <Autocomplete
                        disablePortal
                        id="city-autocomplete"
                        options={citySliceResponse?.data || []}
                        getOptionLabel={(option) => option.name || ""}
                        fullWidth
                        size="small"
                        value={
                          (citySliceResponse?.data || []).find(
                            (option) => option.name === values.city,
                          ) || { name: values.city }
                        }
                        onChange={handleCityChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="City"
                            error={!!errors.city}
                            helperText={errors.city}
                          />
                        )}
                      />
                    </div>
                    <div className="inputfield-container">
                      <TextField
                        id="landmark"
                        name="landmark"
                        label="Landmark"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.landmark}
                        onChange={handleChange}
                        error={!!errors.landmark}
                        helperText={errors.landmark}
                      />
                      <TextField
                        id="zip"
                        name="zip"
                        label="Zip Code"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.zip}
                        onChange={handleChange}
                        error={!!errors.zip}
                        helperText={errors.zip}
                      />
                    </div>
                    <div className="inputfield-container">
                      <TextField
                        id="address"
                        name="address"
                        label="Address"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={values.address}
                        onChange={handleChange}
                        error={!!errors.address}
                        helperText={errors.address}
                      />

                      {/* <Autocomplete
                          multiple
                          label="Users"
                          id="Users"
                          name="users"
                          // options={dataForUserSelection}
                          options={[]}
                          getOptionLabel={(option) =>
                            option?.name || option?.phone
                          }
                          isOptionEqualToValue={(option, value) =>
                            option._id === value._id ||
                            option.name === value.name
                          }
                          // onChange={handleSelectedUser}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={
                                  option.name === "Select All"
                                    // ? formData.users.length ===
                                    //   dataForUserSelection.length - 1
                                    // : selected
                                }
                              />
                              {option.name} {option.phone}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                width: "100%", // Adjust width
                                ".MuiAutocomplete-input": {
                                  height: "6px", // Adjust height
                                  border: "none",
                                },
                              }}
                            />
                          )}
                        /> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        // justifyContent: "space-between",
                      }}
                    >
                      {/* <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={handleBack}
                        // disabled={activeStep === 0}
                        sx={{
                          backgroundColor: "#472878",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#472878",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#b8a6d1", // disabled color
                            color: "#fff",
                            opacity: 0.6, // optional
                          },
                        }}
                      >
                        Back
                      </Button> */}

                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          backgroundColor: "#472878",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#472878",
                          },
                        }}
                      >
                        Next
                      </Button>
                    </div>
                  </form>
                </div>
              )}
              {activeStep === 1 && (
                <div>
                  <form
                    className="main-container"
                    onSubmit={formikShipping.handleSubmit}
                  >
                    <FormControlLabel
                      control={<Checkbox checked={checkBoxState} />}
                      label="Same as Billing Address"
                      onClick={handleCheckboxChange}
                    />
                    <div className="inputfield-container">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={stateSliceResponse?.data || []}
                        getOptionLabel={(option) => option.name}
                        fullWidth
                        size="small"
                        value={
                          (stateSliceResponse?.data || []).find(
                            (option) =>
                              option.name ===
                              (checkBoxState
                                ? values.state
                                : formikShipping.values.state),
                          ) || null
                        }
                        onChange={handleShippingState}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="State"
                            onChange={handleShippingState}
                            error={formikShipping.errors.state ? true : false}
                            helperText={formikShipping.errors.state}
                          />
                        )}
                      />
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={citySliceResponse?.data || []}
                        getOptionLabel={(option) => option.name}
                        fullWidth
                        size="small"
                        value={
                          (citySliceResponse?.data || []).find(
                            (option) =>
                              option.name ===
                              (checkBoxState
                                ? values.city
                                : formikShipping.values.city),
                          ) || null
                        }
                        onChange={handleShippingCity}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="City"
                            onChange={handleShippingCity}
                            error={formikShipping.errors.city ? true : false}
                            helperText={formikShipping.errors.city}
                          />
                        )}
                      />
                    </div>
                    <div className="inputfield-container">
                      <TextField
                        id="landmark"
                        name="landmark"
                        label="Landmark"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={
                          checkBoxState
                            ? values.landmark
                            : formikShipping.values.landmark
                        }
                        onChange={formikShipping.handleChange}
                        error={formikShipping.errors.landmark ? true : false}
                        helperText={formikShipping.errors.landmark}
                      />
                      <TextField
                        id="zip"
                        type="tel"
                        name="zip"
                        label="Zip Code"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={
                          checkBoxState ? values.zip : formikShipping.values.zip
                        }
                        onChange={formikShipping.handleChange}
                        error={formikShipping.errors.zip ? true : false}
                        helperText={formikShipping.errors.zip}
                        inputProps={{ maxLength: 6 }}
                      />
                    </div>
                    <div className="inputfield-container">
                      <TextField
                        id="address"
                        name="address"
                        label="Address"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={
                          checkBoxState
                            ? values.address
                            : formikShipping.values.address
                        }
                        onChange={formikShipping.handleChange}
                        error={formikShipping.errors.address ? true : false}
                        helperText={formikShipping.errors.address}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={handleBack}
                        sx={{
                          backgroundColor: "#472878",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#472878",
                          },
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{
                          backgroundColor: "#472878",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#472878",
                          },
                        }}
                      >
                        Next
                      </Button>
                    </div>
                  </form>
                </div>
              )}

              {activeStep === 2 && (
                <div
                  style={{
                    margin: "20px",
                    padding: "20px",
                    border: "1px solid lightgray",
                    borderRadius: "10px",
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: "20px" }}>
                    <h4 style={{ marginBottom: "10px" }}>Billing Address</h4>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Name:</div>
                      <div>
                        {values.firstName} {values.lastName}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Address:</div>
                      <div>{values.address}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>State:</div>
                      <div>{values.state}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>City:</div>
                      <div>{values.city}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Landmark:</div>
                      <div>{values.landmark}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Zip Code:</div>
                      <div>{values.zip}</div>
                    </div>
                  </div>

                  <div
                    style={{
                      borderBottom: "1px dashed gray",
                      margin: "20px 0px",
                    }}
                  ></div>
                  <div style={{ textAlign: "center", marginBottom: "25px" }}>
                    <h4 style={{ marginBottom: "10px" }}>Shipping Address</h4>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Address:</div>
                      <div>{formikShipping.values.address}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>State:</div>
                      <div>{formikShipping.values.state}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>City:</div>
                      <div>{formikShipping.values.city}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Landmark:</div>
                      <div>{formikShipping.values.landmark}</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>Zip Code:</div>
                      <div>{formikShipping.values.zip}</div>
                    </div>
                  </div>

                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      type="button"
                      variant="contained"
                      onClick={handleBack}
                      sx={{
                        backgroundColor: "#472878",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#472878",
                        },
                      }}
                    >
                      Back
                    </Button>
                    {/* <Button
                      type="submit"
                      variant="contained"
                      // onClick={paymentHandler}
                      onClick={getTransactionIdApi}
                      sx={{
                        backgroundColor: "#472878",
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#472878",
                        },
                      }}
                    >
                      Proceed To Pay
                    </Button> */}
                    <Button
                      onClick={getTransactionIdApi}
                      loading={setsendLinkLoading}
                      variant="contained"
                      disabled={setsendLinkLoading}
                      loadingPosition="end"
                      sx={{
                        backgroundColor: "#472878",
                        color: "white",

                        // Loader (CircularProgress) color override
                        "& .MuiCircularProgress-root": {
                          color: "white !important",
                        },

                        // Text color when disabled/loading
                        "&.Mui-disabled": {
                          color: "white !important",
                          backgroundColor: "#472878 !important",
                        },

                        "&:hover": {
                          backgroundColor: "#472878",
                        },
                      }}
                    >
                      Send Payment Link
                    </Button>
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </Box>
      </div>
    </div>
  );
}
